export default "__VITE_ASSET__hytSYbue__"